<template>
    <v-alert :value="visible" :class="addClass" color="grey darken-1" class="shape cutie text-caption" outlined>
        <slot />
    </v-alert>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'AlertOutline',
})
export default class AlertOutline extends Vue {
    @Prop({ default: true }) visible: boolean;
    @Prop({ default: undefined }) addClass: string;
}
</script>
